/** Nilai default jika database belum tersedia */
export const DEFAULT_BRANDING = {
  title: 'BNet Bill',
  shortTitle: 'BNet Bill',
  subtitle: 'Sistem Manajemen Billing ISP',
  logoUrl: '/logo.svg',
  copyright: `© ${new Date().getFullYear()} BNet Bill. All rights reserved.`,
};

const LOGO_API_SUFFIX = '/settings/branding/logo';

/** Logo kustom dilayani lewat /api/settings/branding/logo (kompatibel semua setup nginx) */
export function resolveLogoUrl(logoUrl?: string | null, logoPath?: string | null): string {
  if (!logoPath && !logoUrl) return DEFAULT_BRANDING.logoUrl;

  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
  const versionMatch = logoUrl?.match(/[?&]v=(\d+)/);
  const version = versionMatch ? `?v=${versionMatch[1]}` : logoUrl?.includes('?v=') ? logoUrl.slice(logoUrl.indexOf('?')) : '';

  if (logoPath || logoUrl?.includes(LOGO_API_SUFFIX)) {
    if (apiUrl.startsWith('http')) {
      const base = apiUrl.replace(/\/api\/?$/, '');
      return `${base}/api${LOGO_API_SUFFIX}${version}`;
    }
    return `/api${LOGO_API_SUFFIX}${version}`;
  }

  if (logoUrl?.startsWith('http://') || logoUrl?.startsWith('https://')) {
    return logoUrl;
  }

  if (logoUrl?.startsWith('/api/')) {
    if (apiUrl.startsWith('http')) {
      const base = apiUrl.replace(/\/api\/?$/, '');
      return `${base}${logoUrl}`;
    }
    return logoUrl;
  }

  return DEFAULT_BRANDING.logoUrl;
}
